import { useContext, useEffect } from "react";
import { AppDB } from "../../App";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import CountryCodeComponet from "../../componets/CountryCodeComponet";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { SpaceHighlightInput } from "../../componets/SpaceHighlightInput";
import { validatePhoneNumber } from "../../componets/ValidationError";

Date.prototype.toIsoString = function () {
  var tzo = -this.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? "0" : "") + norm;
    };
  return (
    this.getFullYear() +
    "-" +
    pad(this.getMonth() + 1) +
    "-" +
    pad(this.getDate()) +
    "T" +
    pad(this.getHours()) +
    ":" +
    pad(this.getMinutes()) +
    ":" +
    pad(this.getSeconds()) +
    dif +
    pad(tzo / 60) +
    ":" +
    pad(tzo % 60)
  );
};

export default function ({
  ignore_validation,
  application,
  setApplication,
  type,
  targetParts = [],
}) {
  var { lookUp } = useContext(AppDB);

  function cleanUpDisability(value){
     if([null,undefined].includes(value)) return ""
     return value
  }

  // 🔑 Ensure application[type] and nested objects exist
  useEffect(() => {
    if (application && !application[type]) {
      setApplication((prev) => ({
        ...prev,
        [type]: {
          name: "",
          middlename: "",
          surname: "",
          dateOfBirth: null,
          genderID: null,
          disabilityID: null,
          cellPhone1: { countryCodeID: null, number: "" },
          cellPhone2: { countryCodeID: null, number: "" },
        },
        village: prev.village || {}, // keep village safe
      }));
    }
  }, [application, type, setApplication]);

  return (
    <div className="grid">
      {(targetParts?.includes(1) || ignore_validation) && (
        <>
          {type !== "amendment" && (
            <div className="col-12 md:col-6 lg:col-4">
              <label>ID Number</label>
              <InputText
                disabled={type === "correction"}
                className="w-full"
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, "");
                  application.idNumber = numericValue;
                  setApplication({ ...application });
                }}
                onKeyDown={(e) => {
                  if (
                    !/[0-9]/.test(e.key) &&
                    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                      e.key
                    )
                  ) {
                    e.preventDefault();
                  }
                }}
                maxLength={12}
                value={application?.idNumber || ""}
              />
            </div>
          )}

          {type !== "correction" && (
            <div className="col-12 md:col-6 lg:col-4">
              <label>Form Serial Number</label>
              <InputText
                className="w-full"
                onChange={(e) => {
                  application.formSerialNumber = e.target.value.toUpperCase();
                  setApplication({ ...application });
                }}
                value={application?.formSerialNumber?.toUpperCase() || ""}
              />
            </div>
          )}

          <div className="col-12 md:col-6 lg-4">
            <label>Application Date</label>
            <Calendar
              value={
                application?.applicationDate
                  ? new Date(application.applicationDate)
                  : null
              }
              dateFormat="dd/mm/yy"
              className="w-full"
              onChange={(e) => {
                const date = e.value;
                if (date) {
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const day = String(date.getDate()).padStart(2, "0");
                  const isoString = `${year}-${month}-${day}T00:00:00.000Z`;

                  setApplication((prev) => ({
                    ...prev,
                    applicationDate: isoString
                  }));
                } else {
                  setApplication((prev) => ({ ...prev, applicationDate: null }));
                }
              }}
            />

          </div>

          <div className="col-12 md:col-6 lg:col-4">
            <label>Surname</label>
            <SpaceHighlightInput
              className="w-full"
              onChange={(e) => {
                application[type].surname = e.target.value.toUpperCase();
                setApplication({ ...application });
              }}
              value={application[type]?.surname?.toUpperCase()}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <label>First Name</label>
            <SpaceHighlightInput
              className="w-full"
              onChange={(e) => {
                application[type].name = e.target.value.toUpperCase();
                setApplication({ ...application });
              }}
              value={application[type]?.name?.toUpperCase()}
            />
          </div>

          <div className="col-12 md:col-6 lg:col-4">
            <label>Middle Name</label>
            <SpaceHighlightInput
              className="w-full"
              onChange={(e) => {
                const value = e.target.value?.toUpperCase() || "";
                application[type].middlename = value.trim() === "" ? null : value;
                setApplication({ ...application });
              }}
              value={application[type]?.middlename?.toUpperCase()}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <label>Date of Birth</label>
            <Calendar
              onChange={(e) => {
                const date = e.value;
                if (date) {
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const day = String(date.getDate()).padStart(2, "0");
                  const isoString = `${year}-${month}-${day}T00:00:00.000Z`;

                  // CORRECT: Update the nested path application[type].dateOfBirth
                  setApplication((prev) => ({
                    ...prev,
                    [type]: {
                      ...prev[type],
                      dateOfBirth: isoString,
                    },
                  }));
                } else {
                  // If date is cleared
                  setApplication((prev) => ({
                    ...prev,
                    [type]: {
                      ...prev[type],
                      dateOfBirth: null,
                    },
                  }));
                }
              }}
              dateFormat="dd/mm/yy"
              value={
                application[type]?.dateOfBirth
                  ? new Date(application[type].dateOfBirth)
                  : null
              }
              className="w-full"
              showIcon
            />
          </div>

          <div className="col-12 md:col-6 lg:col-4">
            <label>Gender</label>
            <Dropdown
              onChange={(e) => {
                application[type].genderID = e.value;
                setApplication({ ...application });
              }}
              value={application[type]?.genderID || null}
              className="w-full"
              optionValue="id"
              optionLabel="name"
              options={lookUp.genders}
            />
          </div>

          <div className="col-12 md:col-6 lg:col-4">
            <label>Disability</label>
            <Dropdown
              onChange={(e) => {
                application[type].disabilityID = e.value;
                setApplication({ ...application });
              }}
              value={cleanUpDisability(application[type]?.disabilityID)}
              className="w-full"
              optionValue="id"
              optionLabel="name"
              options={lookUp.disabilities}
            />
          </div>
        </>
      )}

      {(targetParts?.includes(4) || ignore_validation) && type !== "correction" && (
        <>
          <div className="col-12 md:col-6 lg:col-4">
            <label>Cellphone 1</label>
            <div className="p-inputgroup flex-1">
              <CountryCodeComponet
                style={{ width: 120 }}
                onChange={(e) => {
                  application[type].cellPhone1.countryCodeID = e.value;
                  setApplication({ ...application });
                }}
                value={application[type]?.cellPhone1?.countryCodeID || null}
                optionValue="id"
                optionLabel="name"
                options={lookUp.countryCodes}
              />
              <InputText
                className="w-full"
                onChange={(e) => {
                  application[type].cellPhone1.number = e.target.value.toUpperCase();
                  setApplication({ ...application });
                }}
                value={application[type]?.cellPhone1?.number || ""}
              />
            </div>

            <span className="text-error">
              {validatePhoneNumber(application[type]?.cellPhone1?.number, application[type]?.cellPhone1?.countryCodeID).reason}
            </span>
          </div>

          <div className="col-12 md:col-6 lg:col-4">
            <label>Cellphone 2</label>
            <div className="p-inputgroup flex-1">
              <CountryCodeComponet
                style={{ width: 120 }}
                onChange={(e) => {
                  application[type].cellPhone2.countryCodeID = e.value;
                  setApplication({ ...application });
                }}
                value={application[type]?.cellPhone2?.countryCodeID || null}
                optionValue="id"
                optionLabel="name"
                options={lookUp.countryCodes}
              />
              <InputText
                className="w-full"
                onChange={(e) => {
                  application[type].cellPhone2.number = e.target.value.toUpperCase();
                  setApplication({ ...application });
                }}
                value={application[type]?.cellPhone2?.number || ""}
              />

            </div>
            <span className="text-error">
              {validatePhoneNumber(application[type]?.cellPhone2?.number, application[type]?.cellPhone2?.countryCodeID,true).reason}
            </span>
            
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <label>Email Address</label>
            <div className="p-inputgroup flex-1">
              <InputText
                className="w-full"
                type="email"
                onChange={(e) => {
                  application[type].emailAddress= e.target.value.toUpperCase();
                  setApplication({ ...application });
                }}
                value={application[type]?.emailAddress || ""}
              />
            </div>
            
          </div>
          
        </>
      )}

      {(targetParts?.includes(2) || ignore_validation) && (
        <>
          {type !== "amendment" && type !== "correction" && (
            <div className="col-12">
              <LocalDelimitationNational
                onChange={(id, level) => {
                  if (level === 5) {
                    application.village.villageID = id;
                  } else {
                    application.village.villageID = null;
                  }
                  setApplication({ ...application });
                }}
                councilGridBlock={4}
                midGridBlock={4}
                includeVillage={true}
                isNational={true}
                politicalDelimitation={{
                  districtId: application?.village?.districtID,
                  constituencyId: application?.village?.constituencyID,
                  pollingDivisionId: application?.village?.pollingDivisionID,
                  registrationCentreId: application?.village?.registrationCentreID,
                  villageId: application?.village?.villageID,
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
